module.exports = __webpack_public_path__ + "img/1522240710.c5b0246d.jpg";